function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M24 14.101V23h-5.144v-8.303c0-2.085-.744-3.509-2.606-3.509-1.421 0-2.267.96-2.64 1.887-.135.332-.17.794-.17 1.258V23H8.294s.07-14.062 0-15.519h5.146v2.2l-.034.05h.034v-.05c.683-1.056 1.904-2.565 4.637-2.565 3.385 0 5.923 2.218 5.923 6.985zM2.912 0C1.152 0 0 1.158 0 2.68c0 1.49 1.118 2.684 2.843 2.684h.035c1.794 0 2.91-1.193 2.91-2.683C5.754 1.158 4.672 0 2.912 0zM.306 23h5.143V7.481H.306V23z",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 23"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/linkedin.45665eec.svg";
export { SvgComponent as ReactComponent };